module.exports = __webpack_public_path__ + "images/470c34974a6251a664ac34ed3ba498c1.svg";